<template>
  <div class="list-check-wrap">
    <div class="table-wrap">
      <div class="table-item" style="width: 62%; maring-right: 10px">
        <div class="table-header">
          <span class="header-text">名称</span>
          <!-- <span class="header-text">属性</span> -->
          <span class="header-text">操作</span>
        </div>
        <div class="table-content" style="overflow: auto">
          <div class="item-line" v-for="item of dataList" :key="item.id">
            <span class="item-col" :title="item.name">{{ item.name }}</span>
            <!-- <span class="item-col" :title="item.type">{{ item.type }}</span> -->
            <span style="width: 65px; flex-shrink: 0" class="item-col btn-col">
              <el-button
                type="text"
                class="check-btn"
                :disabled="
                  selectItem.includeList.find(
                    (dataItem) => dataItem.id === item.id
                  )
                    ? true
                    : false || isAutoTarge
                "
                @click="checkItem(item, 'dx')"
                >定向</el-button
              >
              <el-button
                type="text"
                class="check-btn"
                :disabled="
                  selectItem.excludeList.find(
                    (dataItem) => dataItem.id === item.id
                  )
                    ? true
                    : false
                "
                @click="checkItem(item, 'pc')"
                >排除</el-button
              >
            </span>
          </div>
        </div>
      </div>
      <div class="table-item" style="width: 35%">
        <div class="table-header">
          <span class="header-text">已选</span>
          <span
            class="header-text"
            style="color: rgba(24, 144, 255, 1); cursor: pointer"
            @click="clearAllList"
            >清除</span
          >
        </div>
        <div class="table-content">
          <ul class="kind-list">
            <li
              :class="['kind-item', curShow === 'dx' ? 'cur' : '']"
              @click="curShow = 'dx'"
            >
              定向({{ selectItem.includeList.length }})
            </li>
            <li
              :class="['kind-item', curShow === 'pc' ? 'cur' : '']"
              @click="curShow = 'pc'"
            >
              排除({{ selectItem.excludeList.length }})
            </li>
          </ul>
          <div class="select-kind-wrap">
            <div class="data-list" v-show="curShow === 'dx'">
              <div
                class="data-item"
                v-for="item of selectItem.includeList"
                :key="item.id"
              >
                {{ item.name
                }}<i
                  class="el-icon-close close-btn"
                  @click="deleteItem(item)"
                ></i>
              </div>
            </div>
            <div class="data-list" v-show="curShow === 'pc'">
              <div
                class="data-item"
                v-for="item of selectItem.excludeList"
                :key="item.id"
              >
                {{ item.name
                }}<i
                  @click="deleteItem(item)"
                  class="el-icon-close close-btn"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListCheckWrap",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    //是否智能定向
    isAutoTarge: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      curShow: "dx",
      selectItem: {
        includeList: [],
        excludeList: [],
      },
    };
  },
  methods: {
    clearAllList() {
      this.selectItem.excludeList = [];
      this.selectItem.includeList = [];
    },
    deleteItem(item) {
      if (this.curShow === "dx") {
        let delIndex = this.selectItem.includeList.findIndex(
          (dataItem) => dataItem.id === item.id
        );
        this.selectItem.includeList.splice(delIndex, 1);
      } else {
        let delIndex = this.selectItem.excludeList.findIndex(
          (dataItem) => dataItem.id === item.id
        );
        this.selectItem.excludeList.splice(delIndex, 1);
      }
    },
    checkItem(dataItem, type) {
      if (type === "dx") {
        let pcIndex = this.selectItem.excludeList.findIndex(
          (item) => item.id === dataItem.id
        );
        if (pcIndex !== -1) {
          this.selectItem.excludeList.splice(pcIndex, 1);
        }
        this.selectItem.includeList.push(dataItem);
        this.curShow = "dx";
      } else {
        let dxIndex = this.selectItem.includeList.findIndex(
          (item) => item.id === dataItem.id
        );
        if (dxIndex !== -1) {
          this.selectItem.includeList.splice(dxIndex, 1);
        }
        this.selectItem.excludeList.push(dataItem);
        this.curShow = "pc";
      }
    },
  },
  watch: {
    isAutoTarge(value) {
      if (value) {
        this.selectItem.includeList = [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.list-check-wrap {
  width: 800px;
  .table-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    .table-item {
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      .table-header {
        display: flex;
        background: rgba(0, 0, 0, 0.02);
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        justify-content: space-between;
        .header-text {
          display: inline-block;
          width: 80px;
          text-align: center;
          padding: 12px 0;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
        }
      }
      .table-content {
        height: 200px;
        display: flex;
        flex-direction: column;
        .kind-list {
          padding: 0px;
          margin: 0px;
          list-style: none;
          display: flex;
          justify-content: space-around;
          border-bottom: 1px solid rgba(0, 0, 0, 0.2);
          .kind-item {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            padding: 12px 0;
            text-align: center;
            border-bottom: 2px solid transparent;
            cursor: pointer;
            &.cur {
              color: rgba(24, 144, 255, 1);
              border-bottom: 2px solid rgba(24, 144, 255, 1);
            }
          }
        }
        .select-kind-wrap {
          height: 100%;
          overflow: auto;
          .data-list {
            .data-item {
              box-sizing: border-box;
              padding: 5px 20px 5px 5px;
              font-size: 12px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              position: relative;
              .close-btn {
                position: absolute;
                right: 5px;
                top: 8px;
                cursor: pointer;
              }
              &:hover {
                background-color: #f9f9f9;
              }
            }
          }
        }
        .item-line {
          display: flex;
          padding: 5px;
          &:hover {
            background-color: #f9f9f9;
          }
          .item-col {
            font-size: 12px;
            display: inline-block;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .btn-col {
            display: flex;
            justify-content: space-between;
            .check-btn {
              cursor: pointer;
              color: #1890ff;
              padding: 0px;
              margin: 0px;
              font-size: 12px;
              &:disabled {
                color: #b1b1b1;
              }
            }
          }
        }
      }
    }
  }
}
</style>